import { render, staticRenderFns } from "./SendTrainingInvitations.vue?vue&type=template&id=2aac100a&scoped=true&"
import script from "./SendTrainingInvitations.vue?vue&type=script&lang=js&"
export * from "./SendTrainingInvitations.vue?vue&type=script&lang=js&"
import style0 from "./SendTrainingInvitations.vue?vue&type=style&index=0&id=2aac100a&lang=scss&scoped=true&"
import style1 from "./SendTrainingInvitations.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aac100a",
  null
  
)

export default component.exports